import office from '@/taskpane/officejs/office-wrapper'
import { IObserver } from '@/taskpane/common/observer-pattern'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import ItemChangeArgs from '../messages/item-change-args'
import OfficeObservable from './office-observable'

export class AppointmentBodyObservable extends OfficeObservable<string> {
  public eventHandlerType = () => null
  public get = async () => office.body.get(true, null)
}

export default class AppointmentBodyObserver implements IObserver<string> {
  update(body: string): void {
    const args: ItemChangeArgs = {
      data: body,
      type: 'description',
    }
    broadcastMessageToPortals('EventItemDataChange', args)
  }
}
